export enum VideoSessionStatus {
  Uninitialized = -1,
  NoActiveSession = 0,
  InitiatedByVisitor = 1,
  InitiatedByOperator = 2,
  AcceptedByOperator = 3,
  AcceptedByVisitor = 4,
  DeclinedByOperator = 5,
  DeclinedByVisitor = 6,
  EndedByOperator = 7,
  EndedByVisitor = 8,
  EndedByServer = 9
}

export namespace VideoSessionStatus {
  export const hasValue = (videoSessionStatus: VideoSessionStatus): boolean => {
    return typeof VideoSessionStatus[videoSessionStatus] === 'string';
  };

  export const isAccepted = (videoSessionStatus: VideoSessionStatus): boolean => {
    return videoSessionStatus === VideoSessionStatus.AcceptedByOperator ||
      videoSessionStatus === VideoSessionStatus.AcceptedByVisitor;
  };

  export const isInSession = (videoSessionStatus: VideoSessionStatus): boolean => {
    return videoSessionStatus === VideoSessionStatus.InitiatedByVisitor ||
      videoSessionStatus === VideoSessionStatus.InitiatedByOperator ||
      isAccepted(videoSessionStatus);
  };

  export const wasStarted = (videoSessionStatus: VideoSessionStatus): boolean => {
    return videoSessionStatus !== null &&
      videoSessionStatus !== VideoSessionStatus.Uninitialized &&
      videoSessionStatus !== VideoSessionStatus.NoActiveSession;
  };

  const videoSessionEndedStatuses = new Set<VideoSessionStatus>([
    VideoSessionStatus.DeclinedByOperator,
    VideoSessionStatus.DeclinedByVisitor,
    VideoSessionStatus.EndedByOperator,
    VideoSessionStatus.EndedByVisitor,
    VideoSessionStatus.EndedByServer
  ]);

  export const hasEnded = (videoSessionStatus: VideoSessionStatus): boolean =>
    videoSessionEndedStatuses.has(videoSessionStatus);
}
